import { mapState } from 'vuex'
import { MODULE_NAME } from '@/store/site/constants'

const siteConfig = {
  computed: {
    ...mapState(MODULE_NAME, [ 'config' ]),
    clientTitle () {
      return this.config.title
    },
    clientLogo () {
      return this.config.client_logo_img
    },
    clientBackground () {
      return this.config.background_img
    },
    clientBackgroundStyle () {
      return { backgroundImage: `url(${this.clientBackground})` }
    },
    appLogo () {
      return this.config.app_logo_img
    },
    siteColor () {
      return '#ffcd03'
    },
    siteColorStyle () {
      return `--site-color: ${this.siteColor}`
    }
  }
}

export default siteConfig
